import {axiosRequest} from '@src/helpers';
import {ENV} from "@environments/environment";

const {AWS_S3_FILE_UPLOAD, API_URL} = ENV


export const getListLang = async () => {
  return await axiosRequest(`${API_URL}/languages`, {
    method: 'GET'
  });
};

export const getTranslate = async (lang: string) => {
  return await axiosRequest(`${API_URL}/translations${lang ? `?lang=${lang}` : ''}`, {
    method: 'GET'
  });
};
